import request from '@/utils/request'

//获取账单
export function GetAllBillList(params, config = {}) {
  return request({
      url: `/api/other/user-wendu-log/all-bill-lists`,
      method: 'post',
      data: params,
      ...config // 合并传入的配置
  })
}
//获取饭卡/温度卡明细
export function GetFankaList(params, config = {}) {
  return request({
      url: `/api/other/user-fanka-log/fanka-bill-lists`,
      method: 'post',
      data: params,
      ...config // 合并传入的配置
  })
}
//获取饭卡/温度卡余额
export function GetCancaInfo(params, config = {}) {
  return request({
      url: `/api/other/user/canca-info`,
      method: 'post',
      params: params,
      ...config // 合并传入的配置
  })
}
//获取商品详情
export function GetGoodsInfo(params) {
  return request({
      url: `/api/other/user-wendu-log/html-goods-info`,
      method: 'post',
      data: params,
  })
}
//获取OPPO和后台设置的下载地址
export function GetCouponDownUrl( config = {}) {
  return request({
      url: `/api/other/coupon/check-coupon`,
      method: 'post',
      ...config // 合并传入的配置
  })
}
//提交调查问卷
export function GetQuestion(params, config = {}) {
  return request({
      url: `/api/other/questionnaire-log/sub-question`,
      method: 'post',
      data: params,
      ...config // 合并传入的配置
  })
}

